import helpers from "@/mixins/helpers"
import EqCatList from "./components/List"
import EqCatForm from "./components/Form"

let module = "equipment-categories"

export default [
  { path: "equipment-categories", component: EqCatList, meta: { module: module, permissions: ["equipment-access"] } },
  {
    path: "equipment-categories/create",
    component: EqCatForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
  {
    path: "equipment-categories/edit/:id",
    component: EqCatForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
]
